import {
  DevelopmentType,
  EvidenceDirection,
  EvidenceRole,
} from "../../../enums/News";
import { EngagementTheme } from "../../../enums/EngagementTheme";
import {
  compassBordeaux,
  compassLightGreen,
  compassYellow,
  lightGreyOutline,
} from "../../../styles";

export const NEWS_WINDOW_DAYS = 30;
export const NEWS_LIMIT = 100;
export const NEWS_MAX_RANGE_DAYS = 365;
export const NEWS_RANGE_PRESET_DAYS: { label: string; days: number }[] = [
  { label: "Last 30 days", days: 30 },
  { label: "Last 90 days", days: 90 },
  { label: "Last 12 months", days: 365 },
];

export const DIRECTION_COLORS: Record<EvidenceDirection, string> = {
  [EvidenceDirection.POSITIVE]: compassLightGreen,
  [EvidenceDirection.MIXED]: compassYellow,
  [EvidenceDirection.NEGATIVE]: compassBordeaux,
  [EvidenceDirection.NEUTRAL]: lightGreyOutline,
  [EvidenceDirection.UNCLEAR]: lightGreyOutline,
};

export const DIRECTION_LABELS: Record<EvidenceDirection, string> = {
  [EvidenceDirection.POSITIVE]: "positive",
  [EvidenceDirection.MIXED]: "mixed",
  [EvidenceDirection.NEGATIVE]: "negative",
  [EvidenceDirection.NEUTRAL]: "neutral",
  [EvidenceDirection.UNCLEAR]: "unclear",
};

export const STACK_ORDER: EvidenceDirection[] = [
  EvidenceDirection.POSITIVE,
  EvidenceDirection.NEUTRAL,
  EvidenceDirection.UNCLEAR,
  EvidenceDirection.MIXED,
  EvidenceDirection.NEGATIVE,
];

export const LEGEND_DIRECTIONS: EvidenceDirection[] = [
  EvidenceDirection.POSITIVE,
  EvidenceDirection.MIXED,
  EvidenceDirection.NEGATIVE,
];

export const RINGED_DIRECTIONS: EvidenceDirection[] = [
  EvidenceDirection.NEGATIVE,
  EvidenceDirection.MIXED,
];

export const DEVELOPMENT_TYPE_LABELS: Record<DevelopmentType, string> = {
  [DevelopmentType.FINANCIAL_RESULTS]: "Results",
  [DevelopmentType.GUIDANCE_OR_OUTLOOK]: "Guidance",
  [DevelopmentType.STRATEGY_CHANGE]: "Strategy",
  [DevelopmentType.OPERATIONAL_CHANGE]: "Operations",
  [DevelopmentType.COMMERCIAL_DEVELOPMENT]: "Commercial",
  [DevelopmentType.TRANSACTION]: "Transaction",
  [DevelopmentType.FINANCING_OR_CAPITAL_RETURN]: "Financing",
  [DevelopmentType.LEADERSHIP_OR_BOARD_CHANGE]: "Leadership",
  [DevelopmentType.POLICY_OR_COMMITMENT]: "Policy",
  [DevelopmentType.PRODUCT_OR_SERVICE_CHANGE]: "Product",
  [DevelopmentType.WORKFORCE_CHANGE]: "Workforce",
  [DevelopmentType.REGULATORY_CHANGE]: "Regulatory",
  [DevelopmentType.INVESTIGATION]: "Investigation",
  [DevelopmentType.ENFORCEMENT]: "Enforcement",
  [DevelopmentType.LITIGATION]: "Litigation",
  [DevelopmentType.INCIDENT]: "Incident",
  [DevelopmentType.CONTROVERSY_OR_ALLEGATION]: "Controversy",
  [DevelopmentType.DISCLOSURE]: "Disclosure",
  [DevelopmentType.OTHER]: "Other",
};

export const THEME_LABELS: Record<EngagementTheme, string> = {
  [EngagementTheme.CLIMATE_CHANGE]: "Climate change",
  [EngagementTheme.WIDER_SOCIETAL_IMPACTS]: "Societal impacts",
  [EngagementTheme.HUMAN_CAPITAL]: "Human capital",
  [EngagementTheme.BOARD_EFFECTIVENESS]: "Board effectiveness",
  [EngagementTheme.EXECUTIVE_REMUNERATION]: "Executive pay",
  [EngagementTheme.INVESTOR_PROTECTION_AND_RIGHTS]: "Investor rights",
  [EngagementTheme.RISK_MANAGEMENT]: "Risk management",
  [EngagementTheme.HUMAN_AND_LABOUR_RIGHTS]: "Labour rights",
  [EngagementTheme.CIRCULAR_ECONOMY_AND_ZERO_POLLUTION]: "Circular economy",
  [EngagementTheme.PURPOSE_STRATEGY_AND_POLICIES]: "Strategy & policies",
  [EngagementTheme.NATURAL_RESOURCE_STEWARDSHIP]: "Natural resources",
};

export const EVIDENCE_ROLE_LABELS: Record<EvidenceRole, string> = {
  [EvidenceRole.EXTERNAL_FINDING]: "Finding",
  [EvidenceRole.ALLEGATION_OR_CONCERN]: "Allegation",
  [EvidenceRole.OBSERVED_OUTCOME]: "Outcome",
  [EvidenceRole.ACTION_OR_IMPLEMENTATION]: "Action",
  [EvidenceRole.INTENT_OR_COMMITMENT]: "Commitment",
  [EvidenceRole.COMPANY_CLAIM]: "Claim",
  [EvidenceRole.CONTEXT]: "Context",
};

export const EVIDENCE_ROLE_RANK: Record<EvidenceRole, number> = {
  [EvidenceRole.EXTERNAL_FINDING]: 0,
  [EvidenceRole.ALLEGATION_OR_CONCERN]: 1,
  [EvidenceRole.OBSERVED_OUTCOME]: 2,
  [EvidenceRole.ACTION_OR_IMPLEMENTATION]: 3,
  [EvidenceRole.INTENT_OR_COMMITMENT]: 4,
  [EvidenceRole.COMPANY_CLAIM]: 5,
  [EvidenceRole.CONTEXT]: 6,
};
